import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { useTranslation } from 'react-i18next';
import { Button, Grid, Typography, useMediaQuery } from '@material-ui/core';

// UTILITY
import { getS3ImageUrl } from '@/utility/content';
import { analyticsClickedCreateProfile } from '@/utility/analytics';

// HOOKS
import useActions from '@/hooks/useActions';

// STORE
import { AuthActions } from '@/store/actions';

// STYLES
import Container from './styles';

const imagePrefix = 'save-your-apps-';
const image = getS3ImageUrl(`/${imagePrefix}image.svg`);
const imageBg = getS3ImageUrl(`/${imagePrefix}bg-image.svg`);

function BannerSaveYourApps({ className, analyticsLocation }) {
  const [t] = useTranslation();
  const [manageAuthDialogState] = useActions([
    authDialogProps =>
      AuthActions.manageAuthDialogState.action({ state: true, props: authDialogProps }),
  ]);
  const upMd = useMediaQuery(({ breakpoints }) => breakpoints.up('md'));

  function handleCreateProfileClick() {
    const properties = {
      location: analyticsLocation,
    };

    analyticsClickedCreateProfile(properties);

    manageAuthDialogState({});
  }

  return (
    <Container className={clsx('banner-save-your-apps', className)}>
      <Grid className="banner-save-your-apps__content" container spacing={2}>
        <Grid item xs={12} sm={6} className="banner-save-your-apps__content-img">
          <div className="banner-save-your-apps__image">
            <img src={image} alt="banner" />
          </div>
        </Grid>
        <Grid item xs={12} sm={6} className="banner-save-your-apps__content-text">
          <Typography className="banner-save-your-apps__title" variant="h4">
            {t('bannerSaveYourApps.title')}
          </Typography>
          <Typography className="banner-save-your-apps__subtitle p5">
            {t('bannerSaveYourApps.subtitle')}
          </Typography>
          <Button
            className="banner-save-your-apps__button"
            size={upMd ? 'large' : 'medium'}
            color="secondary"
            onClick={handleCreateProfileClick}
          >
            {t('buttons.createYourProfile')}
          </Button>
        </Grid>
      </Grid>

      <img src={imageBg} alt="banner-bg" className="banner-save-your-apps__bg-image" />
    </Container>
  );
}

BannerSaveYourApps.propTypes = {
  className: PropTypes.string,
  analyticsLocation: PropTypes.string.isRequired,
};

export default React.memo(BannerSaveYourApps);
